import React from 'react';
import { Merchandiser } from '../../../redux/composableDevice/model/Merchandiser.model';
import { ListItem } from '../../../../../theme/components';
import { DeviceSoloIcon } from '../../../../../theme/icons';
import MerchandiserActions from './MerchandiserActions';
import { ViewKey } from '../MerchandiserContainer';
import { MerchandiserResume } from './MerchandiserResume';
import { Stack } from '@mui/material';

interface MerchandiserSubheaderProps {
  merchandiserId?: string;
  merchandiser?: Merchandiser;
  loading?: boolean;
  moduleSelected: ViewKey;
  collapsed: boolean;
  onClick?: React.Dispatch<React.SetStateAction<ViewKey>>;
  updateCollapse?: () => void;
}

export function MerchandiserSubheader(props: MerchandiserSubheaderProps) {
  const {
    merchandiser,
    moduleSelected,
    merchandiserId,
    loading,
    collapsed,
    onClick,
    updateCollapse,
  } = props;
  const subtitle =
    merchandiser?.machineType?.labels?.businessFamily &&
    merchandiser?.machineType?.labels?.businessGroup
      ? `${merchandiser?.machineType?.labels?.businessFamily} - ${merchandiser?.machineType?.labels?.businessGroup}`
      : undefined;

  const image =
    merchandiser?.iconURL ?? merchandiser?.composableDevice?.labels?.imageURL;

  return (
    <ListItem
      id={merchandiserId}
      name={merchandiser?.name ?? ''}
      loading={loading}
      collapsed={collapsed}
      iconURL={image}
      subtitle={subtitle}
      onClick={updateCollapse}
      iconNode={!image && <DeviceSoloIcon />}
      buttons={
        <Stack direction="row" spacing={2} alignItems="center">
          {merchandiser && collapsed ? (
            <Stack direction="row" spacing={'0.5rem'} alignItems="center">
              <MerchandiserResume merchandiser={merchandiser} />
              <MerchandiserActions
                merchandiserId={merchandiserId}
                moduleSelected={moduleSelected}
                onClick={onClick || (() => {})}
                diplayJustAlarms={true}
              />
            </Stack>
          ) : null}
          {!collapsed ? (
            <MerchandiserActions
              merchandiserId={merchandiserId}
              moduleSelected={moduleSelected}
              onClick={onClick || (() => {})}
            />
          ) : null}
        </Stack>
      }
      menuButtons={
        <MerchandiserActions
          merchandiserId={merchandiserId}
          moduleSelected={moduleSelected}
          onClick={onClick || (() => {})}
        />
      }
      ItemContainerProps={{
        disableRipple: true,
        sx: {
          ':hover': { backgroundColor: 'background.container' },
          cursor: 'default',
          px: 3,
          backgroundColor: 'background.container',
        },
      }}
    />
  );
}

export default MerchandiserSubheader;
